import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { classNames } from "../../../../../helpers/classNames";
import Image from "../../../../elements/Image";

const DraggableImageItem = ({
  image,
  index,
  selected,
  onToggleSelect,
  onCrop,
  disableSelection = false
}) => {
  // Normal sortable functionality
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: image.id ?? image._id,
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  const disabled = image.regenerateCount >= 2;
  const isRegenerating = image.isRegenerating || false;

  return (
    <div
      ref={setNodeRef}
      style={style}
      {...attributes}
      {...(!isRegenerating && !image.isCover ? listeners : {})} // Disable dragging when regenerating
      className={`relative  transition-all ${!isRegenerating && !image.isCover ? 'cursor-grab active:cursor-grabbing' : 'cursor-not-allowed'
        }`}
    >
      {/* Drag handle indicator */}
      {!isRegenerating && !disabled && (
        <div className="absolute top-1 left-1 opacity-0 group-hover:opacity-100 transition-opacity z-10">
          <div className="bg-gray-600 text-white rounded p-1">
            <i className="fa-solid fa-grip-vertical text-xs"></i>
          </div>
        </div>
      )}

      {/* Regeneration Loading Overlay */}
      {isRegenerating && (
        <div className="absolute inset-0 bg-black/20 backdrop-blur-[1px] rounded-xl z-20 flex items-center justify-center">
          <div className="bg-white/90 rounded-full p-3 shadow-lg">
            <div className="animate-spin rounded-full h-6 w-6 border-2 border-pink-500 border-t-transparent"></div>
          </div>
          <div className="absolute bottom-2 left-0 right-0 text-center">
            <span className="text-xs font-medium text-white bg-black/50 px-2 py-1 rounded-full">
              Regenerating...
            </span>
          </div>
        </div>
      )}

      <div className="group">
        <div className={classNames("border rounded-xl w-full shadow-sm pointer-events-none overflow-hidden group-hover:shadow-lg transition-all duration-200", selected ? "bg-pink-100 border-pink-400" : "bg-white")}>
          <div className={classNames("aspect-[8/11] w-24 md:w-28 overflow-hidden rounded-xl", isDragging && 'opacity-50', isRegenerating && 'opacity-75')}>
            <Image
              src={image.sketchUrl}
              alt={`Page ${index}`}
              classes="w-full h-full object-contain"
            />
          </div>
        </div>


        <div className="relative text-center text-sm py-1 text-gray-400 font-light">
            {image.isCover ? "Cover Page" : `Page ${index}`}
          </div>

        {/* {!image.isCover && (
          <div className="flex justify-between items-center mt-2">
            <input
              type="checkbox"
              disabled={disabled || isRegenerating || disableSelection}
              checked={selected}
              onChange={(e) => {
                e.stopPropagation();
                onToggleSelect(image.id);
              }}
              className={`w-4 h-4 pointer-events-auto ${
                isRegenerating || disabled ? 'opacity-50 cursor-not-allowed' : ''
              }`}
              title={
                isRegenerating 
                  ? "Currently regenerating..."
                  : disabled
                  ? "Regeneration limit reached (2/2)"
                  : disableSelection
                  ? "Cannot regenerate cover images"
                  : "Select to regenerate"
              }
            />
            <button
              className={`bg-white p-1 rounded-full shadow hover:shadow-md transition-shadow pointer-events-auto ${
                isRegenerating || disabled ? 'opacity-50 cursor-not-allowed' : ''
              } ${disabled ? 'bg-red-50 border border-red-200' : ''}`}
              title={
                disabled 
                  ? "Cannot crop - regeneration limit exceeded"
                  : isRegenerating 
                  ? "Currently regenerating..." 
                  : "Crop Image"
              }
              disabled={isRegenerating || disabled}
              onClick={(e) => {
                e.stopPropagation();
                if (!isRegenerating && !disabled) {
                  onCrop();
                }
              }}
            >
              <i className={`fa-solid fa-pen text-sm ${disabled ? 'text-red-400' : 'text-pink-500'}`}></i>
            </button>
          </div>
        )} */}
      </div>
    </div>
  );
};

export default DraggableImageItem;